module.exports = __webpack_public_path__ + "static/media/unspoken_rules.c7a1c04e.svg";